"use strict";
export function validateEmailForm(formData) {
  const errors = {};
  if (!formData.selectedTemplate) {
    errors.template = "Please select an email template";
  }
  if (!formData.subject.trim()) {
    errors.subject = "Subject is required";
  }
  if (!formData.body.trim()) {
    errors.body = "Email body is required";
  }
  return errors;
}
